import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import { isMobile } from "ui/lib/helpers";
import { Room } from "../types";

type RoomDict = { [key: string]: Room };

export interface UseSelectedUserReturnProps {
  hasSelectedUserId: boolean;
  infoPanelActive: boolean;
  setInfoPanelActive: (active: boolean) => void;
  selectedUserId: string;
  setSelectedUserId: (userId: string) => void;
  handleSetSelectedUserId: (userId: string) => void;
}

const isLadderWeb = [
  "http://localhost:3000",
  "https://joinladder.com",
  "https://dev.joinladder.com",
].includes(process.env.NEXT_PUBLIC_DOMAIN as string);

export const useSelectedUser = (
  activeRoomID: string,
  roomDictionary: RoomDict,
  /** Open member info whenever a member is selected (desktop's side panel). */
  autoOpenInfo = !isMobile()
): UseSelectedUserReturnProps => {
  const { push } = useRouter();
  const [infoPanelActive, setInfoPanelActive] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");

  useEffect(() => {
    if (isLadderWeb) return;
    if (!autoOpenInfo) return;
    setInfoPanelActive(!!selectedUserId);
  }, [selectedUserId]);

  useEffect(() => {
    if (isLadderWeb) return;
    if (!activeRoomID) return;
    const room = roomDictionary[activeRoomID];
    if (room?.user?.id) setSelectedUserId(room.user.id);
  }, [activeRoomID, roomDictionary]);

  const handleSetSelectedUserId = useCallback((userId) => {
    if (isLadderWeb) {
      return push(`/members/${userId}`);
    }
    setSelectedUserId(userId);
    setInfoPanelActive(!!userId);
  }, []);

  return {
    hasSelectedUserId: !!selectedUserId,
    infoPanelActive,
    setInfoPanelActive,
    selectedUserId,
    setSelectedUserId,
    handleSetSelectedUserId,
  };
};
